<p-accordion (onOpen)="openAccordion($event)">
    <p-accordionTab header="Lead Type" [selected]="true">
        <p-table [value]="leadsTypes" [scrollable]="true" scrollHeight="180px">
            <ng-template pTemplate="header">
                <tr>
                    <th class="p-col-6">Name</th>
                    <th class="p-col-2">Is Active</th>
                    <th class="p-col-2">Is Default</th>
                    <th class="p-col-2">Action</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-data let-index="rowIndex">
                <tr>
                    <td class="p-col-6">{{data.name}}</td>
                    <td class="p-col-2">{{ data.statusId==1 ? answertypeConstants.Yes : answertypeConstants.No }}</td>
                    <td class="p-col-2">
                        <p-radioButton class="p-mr-2" [disabled]="data.isDefault || data.statusId==2" [value]="true" [(ngModel)]="data.isDefault"
                        (onClick)="makeLeadTypeDefault(data)">
                        </p-radioButton>
                        {{data.isDefault ? answertypeConstants.Yes: answertypeConstants.No}}
                    </td>
                    <td class="p-col-2 action">
                        <span *ngIf="data.organizationId != 0" class="btnBars p-mr-0" (click)="showEditLeadData(data, leadDataTypes[0])"
                            pTooltip="Edit" tooltipPosition="top">
                            <i class="pi pi-pencil"></i>
                        </span>
                        <span *ngIf="data.organizationId != 0 && !data.isDefault" class="btnBars p-mr-0" (click)="delLeadType(data)" pTooltip="Delete"
                             tooltipPosition="top">
                            <i class="pi pi-trash"></i>
                        </span>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </p-accordionTab>
    <p-accordionTab header="Lead Source">
        <p-table #db [value]="leadsSources" [scrollable]="true" scrollHeight="180px">
            <ng-template pTemplate="header">
                <tr>
                    <th class="p-col-6">Name</th>
                    <th class="p-col-2">Is Active</th>
                    <th class="p-col-2">Is Default</th>
                    <th class="p-col-2">Action</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-data let-index="rowIndex">
                <tr>
                    <td class="p-col-6">{{data.name}}</td>
                    <td class="p-col-2">{{ data.statusId==1 ? answertypeConstants.Yes : answertypeConstants.No }}</td>
                    <td class="p-col-2">
                        <p-radioButton class="p-mr-2" [disabled]="data.isDefault || data.statusId==2" [value]="true" [(ngModel)]="data.isDefault"
                        (onClick)="makeLeadSourceDefault(data)">
                        </p-radioButton>
                        {{data.isDefault ? answertypeConstants.Yes: answertypeConstants.No}}
                    </td>
                    <td class="p-col-2 action">
                        <span class="btnBars p-mr-0" *ngIf="data.organizationId != 0" (click)="showEditLeadData(data, leadDataTypes[1])" pTooltip="Edit"
                            tooltipPosition="top"><i class="pi
              pi-pencil"></i></span>
                        <span class="btnBars p-mr-0" *ngIf="data.organizationId != 0 && !data.isDefault" (click)="delLeadSource(data)" pTooltip="Delete"
                            tooltipPosition="top"><i class="pi pi-trash"></i></span>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </p-accordionTab>
    <p-accordionTab header="Rating">
        <p-table [value]="ratings" [scrollable]="true" scrollHeight="180px">
            <ng-template pTemplate="header">
                <tr>
                    <th class="p-col-6">Name</th>
                    <th class="p-col-2">Is Active</th>
                    <th class="p-col-2">Is Default</th>
                    <th class="p-col-2">Action</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-data let-index="rowIndex">
                <tr>
                    <td class="p-col-6">{{data.name}}</td>
                    <td class="p-col-2">{{ data.statusId==1 ? answertypeConstants.Yes : answertypeConstants.No }}</td>
                    <td class="p-col-2">
                        <p-radioButton class="p-mr-2" [disabled]="data.isDefault || data.statusId==2" [value]="true" [(ngModel)]="data.isDefault"
                        (onClick)="makeRatingDefault(data)">
                        </p-radioButton>
                        {{data.isDefault ? answertypeConstants.Yes: answertypeConstants.No}}
                    </td>
                    <td class="p-col-2 action">
                        <span class="btnBars p-mr-0" *ngIf="data.organizationId != 0" (click)="showEditLeadData(data, leadDataTypes[2])" pTooltip="Edit"
                            tooltipPosition="top"><i class="pi
                    pi-pencil"></i></span>
                        <span class="btnBars p-mr-0" *ngIf="data.organizationId != 0 && !data.isDefault" (click)="delRating(data)" pTooltip="Delete"
                            tooltipPosition="top"><i class="pi pi-trash"></i></span>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </p-accordionTab>
    <p-accordionTab header="No. of Employees">
        <p-table [value]="employeesMounts" [scrollable]="true" scrollHeight="180px">
            <ng-template pTemplate="header">
                <tr>
                    <th class="p-col-6">Name</th>
                    <th class="p-col-2">Is Active</th>
                    <th class="p-col-2">Is Default</th>
                    <th class="p-col-2">Action</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-data let-index="rowIndex">
                <tr>
                    <td class="p-col-6">{{data.name}}</td>
                    <td class="p-col-2">{{ data.statusId==1 ? answertypeConstants.Yes : answertypeConstants.No }}</td>
                    <td class="p-col-2">
                        <p-radioButton class="p-mr-2" [disabled]="data.isDefault || data.statusId==2" [value]="true" [(ngModel)]="data.isDefault"
                            (onClick)="makeEmployeesCountDefault(data)">
                        </p-radioButton>
                        {{data.isDefault ? answertypeConstants.Yes: answertypeConstants.No}}
                    </td>
                    <td class="p-col-2 action">
                        <span class="btnBars p-mr-0" *ngIf="data.organizationId != 0" (click)="showEditLeadData(data, leadDataTypes[3])" pTooltip="Edit"
                            tooltipPosition="top"><i class="pi
              pi-pencil"></i></span>
                        <span class="btnBars p-mr-0" *ngIf="data.organizationId != 0 && !data.isDefault" (click)="delEmployeesNo(data)" pTooltip="Delete"
                            tooltipPosition="top"><i class="pi pi-trash"></i></span>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </p-accordionTab>
    <p-accordionTab header="Annual Revenue">
        <p-table [value]="revenue" [scrollable]="true" scrollHeight="180px">
            <ng-template pTemplate="header">
                <tr>
                    <th class="p-col-6">Name</th>
                    <th class="p-col-2">Is Active</th>
                    <th class="p-col-2">Is Default</th>
                    <th class="p-col-2">Action</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-data let-index="rowIndex">
                <tr>
                    <td class="p-col-6">{{data.name}}</td>
                    <td class="p-col-2">{{ data.statusId==1 ? answertypeConstants.Yes : answertypeConstants.No }}</td>
                    <td class="p-col-2">
                        <p-radioButton class="p-mr-2" [disabled]="data.isDefault || data.statusId==2" [value]="true" [(ngModel)]="data.isDefault"
                        (onClick)="makeRevenueDefault(data)">
                        </p-radioButton>
                        {{data.isDefault ? answertypeConstants.Yes: answertypeConstants.No}}
                    </td>
                    <td class="p-col-2 action">
                        <span class="btnBars p-mr-0" *ngIf="data.organizationId != 0" (click)="showEditLeadData(data, leadDataTypes[4])" pTooltip="Edit"
                            tooltipPosition="top"><i class="pi
              pi-pencil"></i></span>
                        <span class="btnBars p-mr-0" *ngIf="data.organizationId != 0 && !data.isDefault" (click)="delRevenue(data)" pTooltip="Delete"
                            tooltipPosition="top"><i class="pi pi-trash"></i></span>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </p-accordionTab>
    <p-accordionTab header="Ownership Type">
        <p-table [value]="ownerships" [scrollable]="true" scrollHeight="180px">
            <ng-template pTemplate="header">
                <tr>
                    <th class="p-col-6">Name</th>
                    <th class="p-col-2">Is Active</th>
                    <th class="p-col-2">Is Default</th>
                    <th class="p-col-2">Action</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-data let-index="rowIndex">
                <tr>
                    <td class="p-col-6">{{data.name}}</td>
                    <td class="p-col-2">{{ data.statusId==1 ? answertypeConstants.Yes : answertypeConstants.No }}</td>
                    <td class="p-col-2">
                        <p-radioButton class="p-mr-2" [disabled]="data.isDefault || data.statusId==2" [value]="true" [(ngModel)]="data.isDefault"
                        (onClick)="makeOwnershipDefault(data)">
                        </p-radioButton>
                        {{data.isDefault ? answertypeConstants.Yes: answertypeConstants.No}}
                    </td>
                    <td class="p-col-2 action">
                        <span class="btnBars p-mr-0" *ngIf="data.organizationId != 0" (click)="showEditLeadData(data,
                  leadDataTypes[5])" pTooltip="Edit" tooltipPosition="top"><i class="pi
                    pi-pencil"></i></span>
                        <span class="btnBars p-mr-0" *ngIf="data.organizationId != 0 && !data.isDefault" (click)="delOwnership(data)" pTooltip="Delete"
                            tooltipPosition="top"><i class="pi pi-trash"></i></span>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </p-accordionTab>
    <p-accordionTab header="Industry">
        <p-table [value]="industries" [scrollable]="true" scrollHeight="180px">
            <ng-template pTemplate="header">
                <tr>
                    <th class="p-col-6">Name</th>
                    <th class="p-col-2">Is Active</th>
                    <th class="p-col-2">Is Default</th>
                    <th class="p-col-2">Action</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-data let-index="rowIndex">
                <tr>
                    <td class="p-col-6">{{data.name}}</td>
                    <td class="p-col-2">{{ data.statusId==1 ? answertypeConstants.Yes : answertypeConstants.No }}</td>
                    <td class="p-col-2">
                        <p-radioButton class="p-mr-2" [disabled]="data.isDefault || data.statusId==2" [value]="true" [(ngModel)]="data.isDefault"
                        (onClick)="makeIndustryDefault(data)">
                        </p-radioButton>
                        {{data.isDefault ? answertypeConstants.Yes: answertypeConstants.No}}
                    </td>
                    <td class="p-col-2 action">
                        <span class="btnBars p-mr-0" *ngIf="data.organizationId != 0" (click)="showEditLeadData(data, leadDataTypes[6])" pTooltip="Edit"
                            tooltipPosition="top"><i class="pi
              pi-pencil"></i></span>
                        <span class="btnBars p-mr-0" *ngIf="data.organizationId != 0 && !data.isDefault" (click)="delIndustry(data)" pTooltip="Delete"
                            tooltipPosition="top"><i class="pi pi-trash"></i></span>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </p-accordionTab>
    <p-accordionTab header="Lead Email">
        <p-table [value]="leadsEmail" [scrollable]="true" scrollHeight="180px">
            <ng-template pTemplate="header">
                <tr>
                    <th class="p-col-10">Name</th>
                    <th class="p-col-2">Action</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-data let-index="rowIndex">
                <tr>
                    <td class="p-col-10">{{data.name}}</td>
                    <td class="p-col-2 action">
                        <span class="btnBars p-mr-0" (click)="showEditLeadData(data, leadDataTypes[7])" pTooltip="Edit"
                            tooltipPosition="top"><i class="pi
              pi-pencil"></i></span>
                        <span class="btnBars p-mr-0" *ngIf="!data.systemGenerated" (click)="delLeadEmail(index)"
                            pTooltip="Delete" tooltipPosition="top"><i class="pi pi-trash"></i></span>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </p-accordionTab>
    <p-accordionTab header="Lead Phone">
        <p-table [value]="leadsPhone" [scrollable]="true" scrollHeight="180px">
            <ng-template pTemplate="header">
                <tr>
                    <th class="p-col-10">Name</th>
                    <th class="p-col-2">Action</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-data let-index="rowIndex">
                <tr>
                    <td class="p-col-10">{{data.name}}</td>
                    <td class="p-col-2 action">
                        <span class="btnBars p-mr-0" (click)="showEditLeadData(data, leadDataTypes[8])" pTooltip="Edit"
                            tooltipPosition="top"><i class="pi
              pi-pencil"></i></span>
                        <span class="btnBars p-mr-0" *ngIf="!data.systemGenerated" (click)="delLeadPhone(index)"
                            pTooltip="Delete" tooltipPosition="top"><i class="pi pi-trash"></i></span>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </p-accordionTab>
    <p-accordionTab header="Lead Social Profile">
        <p-table [value]="leadsSocial" [scrollable]="true" scrollHeight="180px">
            <ng-template pTemplate="header">
                <tr>
                    <th class="p-col-10">Name</th>
                    <th class="p-col-2">Action</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-data let-index="rowIndex">
                <tr>
                    <td class="p-col-10">{{data.name}}</td>
                    <td class="p-col-2 action">
                        <span class="btnBars p-mr-0" (click)="showEditLeadData(data, leadDataTypes[9])" pTooltip="Edit"
                            tooltipPosition="top"><i class="pi
              pi-pencil"></i></span>
                        <span class="btnBars p-mr-0" *ngIf="!data.systemGenerated" (click)="delLeadSocial(index)"
                            pTooltip="Delete" tooltipPosition="top"><i class="pi pi-trash"></i></span>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </p-accordionTab>
    <p-accordionTab header="Lead Status">
        <p-table [value]="leadsStatus" [scrollable]="true" scrollHeight="180px">
            <ng-template pTemplate="header">
                <tr>
                    <th class="p-col-10">Name</th>
                    <th class="p-col-2">Action</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-data let-index="rowIndex">
                <tr>
                    <td class="p-col-10">{{data.name}}</td>
                    <td class="p-col-2 action">
                        <span class="btnBars p-mr-0" (click)="showEditLeadData(data, leadDataTypes[10])" pTooltip="Edit"
                            tooltipPosition="top"><i class="pi
              pi-pencil"></i></span>
                        <span class="btnBars p-mr-0" (click)="delLeadStatus(data)" pTooltip="Delete"
                            tooltipPosition="top"><i class="pi pi-trash"></i></span>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </p-accordionTab>
    <p-accordionTab header="Qualified Reason">
        <p-table [value]="qualifiedReasons" [scrollable]="true" scrollHeight="180px">
            <ng-template pTemplate="header">
                <tr>
                    <th class="p-col-6">Name</th>
                    <th class="p-col-2">Is Active</th>
                    <th class="p-col-2">Is Default</th>
                    <th class="p-col-2">Action</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-data let-index="rowIndex">
                <tr style="cursor: move;">
                    <td class="p-col-6">{{data.name}}</td>
                    <td class="p-col-2">{{data.statusId==1?answertypeConstants.Yes: answertypeConstants.No}}</td>
                    <td class="p-col-2">
                        <p-radioButton class="p-mr-2" [disabled]="data.isDefault || data.statusId==2" [value]="true" [(ngModel)]="data.isDefault"
                            (onClick)="makeDefault(data)"></p-radioButton>
                        {{data.isDefault ? answertypeConstants.Yes: answertypeConstants.No}}
                    </td>
                    <td class="p-col-2 action">
                        <span class="btnBars p-mr-0" (click)="showEditLeadData(data, leadDataTypes[11])" pTooltip="Edit"
                            tooltipPosition="top"><i class="pi pi-pencil"></i></span>
                        <span class="btnBars p-mr-0" (click)="deleteQualifyReason(data, leadDataTypes[11])"
                            pTooltip="Delete" tooltipPosition="top" *ngIf="!data.isDefault"><i class="pi pi-trash"></i></span>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </p-accordionTab>
    <p-accordionTab header="UnQualified Reason">
        <p-table [value]="unQualifiedReasons" [scrollable]="true" scrollHeight="180px">
            <ng-template pTemplate="header">
                <tr>
                    <th class="p-col-6">Name</th>
                    <th class="p-col-2">Is Active</th>
                    <th class="p-col-2">Is Default</th>
                    <th class="p-col-2">Action</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-data let-index="rowIndex">
                <tr style="cursor: move;">
                    <td class="p-col-6">{{data.name}}</td>
                    <td class="p-col-2">{{data.statusId==1?answertypeConstants.Yes: answertypeConstants.No}}</td>
                    <td class="p-col-2">
                        <p-radioButton class="p-mr-2" [disabled]="data.isDefault || data.statusId==2" [value]="true" [(ngModel)]="data.isDefault"
                            (onClick)="makeDefault(data)"></p-radioButton>
                        {{data.isDefault ? answertypeConstants.Yes: answertypeConstants.No}}
                    </td>
                    <td class="p-col-2 action">
                        <span class="btnBars p-mr-0" (click)="showEditLeadData(data, leadDataTypes[12])" pTooltip="Edit"
                            tooltipPosition="top"><i class="pi pi-pencil"></i></span>
                        <span class="btnBars p-mr-0" (click)="deleteQualifyReason(data, leadDataTypes[12])"
                            pTooltip="Delete" tooltipPosition="top" *ngIf="!data.isDefault"><i class="pi pi-trash"></i></span>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </p-accordionTab>
    <p-accordionTab header="Active Reason">
        <p-table [value]="activeReason" [scrollable]="true" scrollHeight="180px">
            <ng-template pTemplate="header">
                <tr>
                    <th class="p-col-6">Name</th>
                    <th class="p-col-2">Is Active</th>
                    <th class="p-col-2">Is Default</th>
                    <th class="p-col-2">Action</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-data let-index="rowIndex">
                <tr style="cursor: move;">
                    <td class="p-col-6">{{ data.name }}</td>
                    <td class="p-col-2">{{ data.statusId==1 ? answertypeConstants.Yes : answertypeConstants.No }}</td>
                    <td class="p-col-2">
                        <p-radioButton class="p-mr-2" [disabled]="data.isDefault || data.statusId==2" [value]="true" [(ngModel)]="data.isDefault"
                            (onClick)="makeActiveInactiveDefault(data)"></p-radioButton>
                        {{data.isDefault ? answertypeConstants.Yes: answertypeConstants.No}}
                    </td>
                    <td class="p-col-2 action">
                        <span class="btnBars p-mr-0" (click)="showEditLeadData(data, leadDataTypes[13])" pTooltip="Edit"
                            tooltipPosition="top"><i class="pi pi-pencil"></i></span>
                        <span class="btnBars p-mr-0" (click)="deleteActiveInactiveReason(data, leadDataTypes[13])"
                            pTooltip="Delete" tooltipPosition="top" *ngIf="data.isDefault == false"><i class="pi pi-trash"></i></span>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </p-accordionTab>
    <p-accordionTab header="Inactive Reason">
        <p-table [value]="inactiveReason" [scrollable]="true" scrollHeight="180px">
            <ng-template pTemplate="header">
                <tr>
                    <th class="p-col-6">Name</th>
                    <th class="p-col-2">Is Active</th>
                    <th class="p-col-2">Is Default</th>
                    <th class="p-col-2">Action</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-data let-index="rowIndex">
                <tr style="cursor: move;">
                    <td class="p-col-6">{{ data.name }}</td>
                    <td class="p-col-2">{{ data.statusId==1 ? answertypeConstants.Yes : answertypeConstants.No }}</td>
                    <td class="p-col-2">
                        <p-radioButton class="p-mr-2" [disabled]="data.isDefault || data.statusId==2" [value]="true" [(ngModel)]="data.isDefault"
                            (onClick)="makeActiveInactiveDefault(data)"></p-radioButton>
                        {{data.isDefault ? answertypeConstants.Yes: answertypeConstants.No}}
                    </td>
                    <td class="p-col-2 action">
                        <span class="btnBars p-mr-0" (click)="showEditLeadData(data, leadDataTypes[14])" pTooltip="Edit"
                            tooltipPosition="top"><i class="pi pi-pencil"></i></span>
                        <span class="btnBars p-mr-0" (click)="deleteActiveInactiveReason(data, leadDataTypes[14])"
                            pTooltip="Delete" tooltipPosition="top" *ngIf="data.isDefault != true "><i class="pi pi-trash"></i></span>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </p-accordionTab>
    
    <!-- <p-accordionTab header="Email To Lead">
        <p-table
        [value]="emailToLead"
        [scrollable]="true"
        scrollHeight="180px"
        >
            <ng-template pTemplate="header">
                <tr>
                    <th class="p-col-10">Name</th>
                    <th class="p-col-2">Value</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-data let-index="rowIndex">
                <tr>
                    <td class="p-col-10">{{ data?.name }}</td>
                    <td class="p-col-2 action">
                        <p-button
                            (click)="confirm(data)"
                            icon="pi pi-check"
                            label="Yes"
                            *ngIf="data?.isDefault"
                        ></p-button>
                        <p-button
                            (click)="confirm(data)"
                            icon="pi pi-times"
                            label="No"
                            *ngIf="!data?.isDefault"
                        ></p-button>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </p-accordionTab> -->
    <p-accordionTab header="Email To Lead">
        <shared-email-to-module-record
          [channels]="allLeadChannels"
          [moduleName]="moduleName">
        </shared-email-to-module-record>
      </p-accordionTab>
            <!-- ---------------------------------tags added -->
    <p-accordionTab header="Tags">
        <p-table [value]="tagList" [scrollable]="true" scrollHeight="180px">
        <ng-template pTemplate="header">
            <tr>
            <th style="max-width:3rem"></th>
            <th class="p-col-6">Name</th>
            <th class="p-col-2">Is Active</th>
            <th class="p-col-2">Action</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-data let-index="rowIndex">
            <tr>
            <td style="max-width:3rem" class="action">
                <span class="pi pi-bars"></span>
            </td>
            <td class="p-col-6">
                <p-tag [value]="data?.name" class="p-ml-2" [style]="{'background-color': data?.color}"></p-tag>
            </td>
            <td class="p-col-2">{{ data.statusId==1 ? answertypeConstants.Yes : answertypeConstants.No }}</td>
            <td class="p-col-2 action">
                <span *ngIf="data.organizationId != 0" class="btnBars p-mr-0" (click)="showEditTag(data)" pTooltip="Edit"
                tooltipPosition="top">
                <i class="pi pi-pencil"></i>
                </span>
                <span *ngIf="data.organizationId != 0" class="btnBars p-mr-0" pTooltip="Delete" tooltipPosition="top"
                (click)="deleteTag(data)">
                <i class="pi pi-trash"></i>
                </span>
            </td>
            </tr>
        </ng-template>
        </p-table>
    </p-accordionTab>
</p-accordion>

<p-dialog header="{{addEditLeadHeader}}" [modal]="true" [(visible)]="displayAddLeadData" [style]="{width: '50vw'}"
    [baseZIndex]="10000">
    <form #leadAddFieldForm="ngForm">
        <div class="p-grid">
            <div class="p-col-12" *ngIf="addEditLeadHeader == 'Add Field Data'">
                <label for="type">Fields Type <span style="color: red;">*</span></label>
                <p-dropdown [options]="leadDataTypes" [(ngModel)]="selectedLeadDataType" #leadDataType="ngModel"
                    optionLabel="name" placeholder="Select Field Type" [ngModelOptions]="{standalone: true}"
                    appendTo="body" (onChange)="getLeadDataType()"
                    [ngClass]="{ 'p-invalid': !selectedLeadDataType && showValidation}"></p-dropdown>
                <small *ngIf="!selectedLeadDataType && showValidation" class="p-invalid">
                    Field Type is required
                </small>
            </div>

            <div class="p-col-12" *ngIf="subscriptionLimitReached">
                <app-subscription-limit-message
                    [subscriptionLimit]="subscriptionLimit"
                    [moduleName]="'Tags'">
                </app-subscription-limit-message>
            </div>
            <ng-container *ngIf="!subscriptionLimitReached">
                <div class="p-col-12" *ngIf="addEditLeadHeader == 'Edit Field Data'">
                    <div class="header">
                        <h5>Fields Name -- {{leadDataTypes[leadTypeId].name}}
                            <p-inputSwitch *ngIf="showActiveBtn" class="header-switch"
                                [(ngModel)]="leadDataTemp.isActive" [ngModelOptions]="{standalone: true}"
                                [disabled]="leadDataTemp && leadDataTemp.isDefault">
                            </p-inputSwitch>
                        </h5>
                    </div>
                    <!-- <h5 class="p-mb-0">Fields Name -- {{leadDataTypes[leadTypeId].name}}</h5> -->
                </div>
                <div class="p-col-12">
                    <label for="name">Name <span style="color: red;">*</span></label>
                    <input
                        id="name"
                        type="text"
                        [ngModelOptions]="{standalone: true}"
                        pInputText
                        [ngModel]="leadDataTemp?.name"
                        #dataName="ngModel"
                        [ngClass]="{ 'p-invalid': showValidation && !leadDataTemp.name}"
                        (ngModelChange)="leadDataTemp.name= $event">
                    <small *ngIf="showValidation && !leadDataTemp.name" class="p-invalid">
                        Name is required
                    </small>
                    <small *ngIf="invalidData" class="p-invalid">
                        Name exists in the list already
                    </small>
                </div>
                <div *ngIf="selectedLeadDataType?.id != 15"  class="p-col-12">
                    <label for="description">Description</label>
                    <input
                        pInputText
                        id="description" type="text"
                        [ngModelOptions]="{standalone: true}"
                        [ngModel]="leadDataTemp?.description"
                        (ngModelChange)="leadDataTemp.description= $event"
                        style="width: 100%;" />
                </div>
                <div *ngIf="selectedLeadDataType?.id == 15" class="p-col-12">
                    <label for="color">Tag Color</label>
                    <p-colorPicker
                        id="color"
                        format="hex"
                        [ngModel]="color"
                        (ngModelChange)="leadDataTemp.color = $event"
                        appendTo="body">
                    </p-colorPicker>
                </div>
            </ng-container>
        </div>
    </form>

    <ng-template pTemplate="footer">
        <button
            pButton
            label="Cancel"
            class="p-button-secondary"
            (click)="cancleAddEditFieldData();">
        </button>
        <button *ngIf="!subscriptionLimitReached" pButton (click)="saveLeadDataAdd()" label="Save"></button>
    </ng-template>
</p-dialog>

<p-dialog header="Edit Tags" [modal]="true" [(visible)]="displayEditTag" [style]="{width: '50vw'}" [baseZIndex]="10000">
    <div class="p-col-12">
      <div class="header">
        <h5 class="p-mb-0">{{'Configuration.CRM.Fields_Name' | transloco}} -- Tags
          <p-inputSwitch class="header-switch" [ngModelOptions]="{standalone: true}" [(ngModel)]="tempTag.isActive">
          </p-inputSwitch>
        </h5>
      </div>
    </div>
    <div class="card" style="min-height: 300px;">
      <div class="p-grid">
        <div class="p-col-12">
          <label>Tag Name</label>
          <input type="text" pInputText [(ngModel)]="tempTag.name">
        </div>
      </div>
      <div class="p-grid">
        <div class="p-col-12">
          <label>Tag color</label>
          <p-colorPicker [(ngModel)]="tempTag.color" appendTo="body"></p-colorPicker>
        </div>
      </div>
    </div>
    <ng-template pTemplate="footer">
      <button pButton label="Cancel" (click)='displayEditTag=false' class="p-button-secondary"></button>
      <button pButton (click)="saveTag();" label="Save"></button>
    </ng-template>
  </p-dialog>

<p-confirmDialog [style]="{width: '20vw'}" [baseZIndex]="1000000"></p-confirmDialog>
